<section id="intro-app-development" class="section-bg-dark">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 pl-5">
                <h2 class="text-white">UX & UI DESIGN</h2>
            </div>
        </div>
    </div>
</section>

<section id="ux_services">
    <div class="container">

        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <p class="font-medium">
                    Diseño de experiencias de usuario e interfaces web y móviles tomando como punto de partida el comportamiento del usuario cuando navega por la web.
                </p>
            </div>
            <div class="col-sm-6 col-xs-12">
                <p class="font-medium">
                    Nuestros proyectos contemplan estrategias de usabilidad web que tienen como fin mejorar la interacción, la experiencia y el atractivo para el usuario.
                </p>
            </div>
        </div>

    </div>

    <div class="container">

        <div class="row justify__content-center">
            <div class="col-xs-12">
                <h2 class="section-title-black align__element-center w-100">
                    Nuestro proceso de diseño
                </h2>
            </div>
        </div>

        @for (section of sections; track section; let i = $index) {
        <div class="row border_black">
            <div class="col-xs-12 col-sm-6 text-center">
                <img src="{{ section.icon }}" alt="icon">
            </div>
            <div class="col-xs-12 col-sm-6">
                <h4>{{ section.title }}</h4>
                <p>{{ section.description }}</p>
            </div>
        </div>

        @if (i < sections.length - 1) {
        <div class="row justify__content-center mt-3 mb-3">
            <div class="col-xs-12 text-center">
                <img src="assets/img/chevdown.png" alt="chevdown" class="filter-teal" width="60px">
            </div>
        </div>
        }
        }

    </div>
</section>